module.exports = __webpack_public_path__ + "static/media/oculus-logo-2.62a9dd24.svg";